import React from 'react';
import Uganda_p4 from './uganda_p4';
import Uganda_p4_subjects from './uganda_p4_subjects';
const Uganda_p4eng = () => {
  return (
    <div>
     <Uganda_p4 />
    <Uganda_p4_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1> English</h1>
      <h3>English content</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in English learning and assessment </li>
      <li>Cross-cutting isues integrated in English learning and assessment </li>
      <li>Values integrated in English learning and assessment </li>
    </div>  
    </div>
  );
}

export default Uganda_p4eng;